import { JSX, useEffect } from "react";
import { getCareJourneyDefinitions } from "@app/projects/servicing-provider/ServicingProviderHelpers";
import { CareJourneyScoresValueEnum } from "./CareJourneyScoresValueEnum";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";

interface CareJourneyScoresProps {
  careJourneyScoreValues: DropdownItem<CareJourneyScoresValueEnum>[];
  selectedValues: DropdownItem<CareJourneyScoresValueEnum>[];
  setSelectedValues: (selectedValues: DropdownItem<CareJourneyScoresValueEnum>[]) => void;
  testId: string;
  title: string;
  disabled?: boolean;
}

const CareJourneyScoresFilter = (props: CareJourneyScoresProps): JSX.Element => {
  useEffect(() => {
    props.setSelectedValues(props.careJourneyScoreValues);
  }, []);

  return (
    <MultiselectDropdown
      containerClassName="d-block"
      customSelectInputText={props.selectedValues.length === props.careJourneyScoreValues.length ? "All" : null}
      disabled={props.disabled}
      items={props.careJourneyScoreValues}
      onSelectionChanged={(selectedValues: DropdownItem<CareJourneyScoresValueEnum>[]) => { props.setSelectedValues(selectedValues) }}
      label={props.title}
      selectedItems={props.selectedValues}
      testId={props.testId}
      validationTooltipContent={getCareJourneyDefinitions()}
    />
  )
}

export default CareJourneyScoresFilter;
